// @ actions
const signaturePatternActions = require('actions/signaturePattern');
// @ constants
const actionTypes = require('constants/actionTypes');
const { CARD_DEPOSIT_MONEY_PUESTO_FISICO, FIRST_STEP } = require('constants/index');
// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder.js');
const { formatAmountForService } = require('utilities/currencyHelper');

function setAmount(amount) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_SET_AMOUNT,
        payload: {
            amount
        }
    };
}

function setFromAccount(fromAccount, fromAccountBalance) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_SET_ACCOUNT,
        payload: {
            fromAccount,
            fromAccountBalance
        }
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function validateStep(step) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

function setWillCancel(willCancel) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function clearRequest() {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_CLEAR
    };
}

function successDeposit() {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_SUCCESS
    };
}

function requestDeposit() {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_REQUEST
    };
}

function failureDeposit(error) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_FAILURE,
        error
    };
}

function setCreditCardData(totalContractBalanceDrawnAmount, creditCardLimit) {
    return {
        type: actionTypes.CARD_DEPOSIT_MONEY_SET_CREDIT_CARD_DATA,
        payload: {
            totalContractBalanceDrawnAmount,
            creditCardLimit
        }
    };
}

const setAllAccountsToInactive = () =>({
    type: actionTypes.CARD_DEPOSIT_MONEY_SET_ALL_ACCOUNTS_TO_INACTIVE
});

const getContactCenterPostDepositCallback = (cardId, accountId) => (dispatch, getState, dataToken) => {
    const immCardDepositMoney = getState().cardDepositMoney.getIn([ 'steps', FIRST_STEP ]);
    const immCard = getState().cards.getIn([ 'byId', cardId ]);
    const immAccount = getState().accounts.getIn([ 'byId', accountId ]);
    const requestData = {
        query:  {
            "contratoTarjeta": {
                "numerodecontrato": immCard.getIn(['contract', 'number']),
                "producto": immCard.getIn(['contract', 'product'])
            },
            "cuentaDeCargo": {
                "numerodecontrato": immAccount.get('contractNumber'),
                "producto": immAccount.get('product')
            },
            "importeIngreso": {
                "divisa": immCardDepositMoney.get('currency'),
                "importe": formatAmountForService(immCardDepositMoney.get('amount'))
            },
            "panTarjeta": immCard.get('number'),
            dataToken
        }
    };

    dispatch(requestDeposit());
    APIPost(dispatch, apiURLBuilder.getURL('cardDepositConfirmation'), requestData)
        .then(response => dispatch(successDeposit(response)))
        .catch(response => dispatch(failureDeposit(response)));
};

const postDeposit = (cardId, accountId) => (dispatch, getState) => {
    const callback = !__CONTACT_CENTER__ ? (dispatch, getState, dataToken) => {
        const immCardDepositMoney = getState().cardDepositMoney.get('steps').get('0');
        const immCard = getState().cards.get('byId').get(cardId);
        const immAccount = getState().accounts.get('byId').get(accountId);
        const requestData = {
            query:  {
                "contrato": {
                    "producto": immCard.getIn(['contract', 'product']),
                    "numerodecontrato": immCard.getIn(['contract', 'number'])
                },
                "cuentaCargo": {
                    "codbban": immAccount.getIn(['ibanComplex', 'codbban']),
                    "digitodecontrol": immAccount.getIn(['ibanComplex', 'digitodecontrol']),
                    "pais": immAccount.getIn(['ibanComplex', 'pais'])
                },
                "importeIngresoCtoJRECLPAG": {
                    "divisa": immCardDepositMoney.get('currency'),
                    "importe": immCardDepositMoney.get('amount')
                },
                "numeroTarjetaPANMDP": immCard.get('number'),
                "puestoFisico": CARD_DEPOSIT_MONEY_PUESTO_FISICO,
                "recarga": "recarga",
                dataToken
            }
        }

        dispatch(requestDeposit());
        APIPost(dispatch, apiURLBuilder.getURL('cardDepositConfirmation'), requestData)
            .then(response => dispatch(successDeposit(response)))
            .catch(response => dispatch(failureDeposit(response)));
    } : getContactCenterPostDepositCallback(cardId, accountId);

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setAllAccountsToInactive,
    setAmount,
    setFromAccount,
    setVisibleStep,
    validateStep,
    setWillCancel,
    clearRequest,
    postDeposit,
    setCreditCardData
}
